import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render judging committee section for FAQ Page
 */
const JudgingCommittee = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="judging-committee-component"
    >
      <AccordionV2
        testId="launch"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Who sits on the judging committee?"
            className="px-0 font-medium"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <p className="m-0 px-6 pb-2 pt-4">
          The judging panel consists of representatives from The Business Times,
          KPMG, Enterprise Singapore and the Singapore Business Federation.
        </p>
      </AccordionV2>
    </div>
  );
};

export default JudgingCommittee;
